var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessengerGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#9a9da2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.8335 2.33398c-4.08334 0-7.5 3.08334-7.5 7 0 2.16662 1.08333 4.08332 2.75 5.41662v2.5834l2.5-1.5c.66666.25 1.41666.3333 2.16666.3333 4.08334 0 7.50004-3.0833 7.50004-6.99998 0-3.91667-3.3334-6.83334-7.4167-6.83334z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.25 10.8333 2.70833-2.49997 1.54167 2.08337 2.8333-2.9167"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerGrey);
export default __webpack_public_path__ + "static/media/messenger_grey.9c2309d43ec47ba881e515d8b7c142b8.svg";
export { ForwardRef as ReactComponent };